function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import sharedCss from "./sharedCheckCss";
import { white } from "@churchofjesuschrist/eden-style-constants";
export const InternalUseOnlyRadio = styled.input.attrs({
  type: "radio"
}).withConfig({
  componentId: "sc-bv55qe-0"
})(["", ";border-radius:50%;&:checked{box-shadow:inset 0px 0px 0px 3px ", ";}"], sharedCss, white);

/**
 * The Radio component is used when there are two or more options and the user must choose only one.
 */
const Radio = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    name,
    required,
    checked,
    value,
    onChange,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(InternalUseOnlyRadio, _extends({
    name: name,
    required: required,
    checked: checked,
    value: value,
    onChange: onChange,
    ref: ref
  }, props));
});
Radio.displayName = "Radio";
Radio.propTypes = {
  /** Used to reference the input in JavaScript, or to reference form data after a form is submitted */
  name: PropTypes.string,
  /** Whether the input is required to be filled out to validate */
  required: PropTypes.bool,
  /** Whether the Radio is active or not */
  checked: PropTypes.bool,
  /** Value of the Radio   */
  value: PropTypes.string,
  /** Callback to execute when the Radio is toggled */
  onChange: PropTypes.func
};
export default Radio;